import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Icon } from '@common/ui/components';
import { useDispatch } from 'react-redux';
import { openSideMenu } from '@common/redux/modules/channel/reducers';

type Props = {
  title?: string;
  isBack?: boolean;
  isMenu?: boolean;
  backUrl?: string;
};

function NavBar({ title, isBack, backUrl, isMenu }: Props) {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleBack = () => {
    if (backUrl) {
      history.push(backUrl);
      return;
    }

    history.goBack();
  };

  function openMenu() {
    dispatch(openSideMenu());
  }

  return (
    <S_NavBar isBack={isBack}>
      {isMenu && (
        <S_Button
          onClick={() => {
            openMenu();
          }}
        >
          <Icon iconName="ic_Menu" />
        </S_Button>
      )}
      {isBack && (
        <S_Button onClick={handleBack}>
          <Icon iconName="ic_ArrowLeft" />
        </S_Button>
      )}
      {!isBack && !isMenu && <S_Empty />}

      {title && <S_Title>{title}</S_Title>}
      <S_EmptyDiv />
    </S_NavBar>
  );
}

const S_NavBar = styled.div<{ isBack?: boolean }>`
  align-items: center;
  background-color: ${({ theme }) => theme.white};
  display: flex;
  height: 56px;
  justify-content: space-between;
  left: 0;
  padding-left: 8px;
  padding-right: 8px;
  position: fixed;
  right: 0;
  text-align: center;
  top: 0;
  transition: transform 0.4s;
  z-index: ${({ isBack }) => (isBack ? 10 : 4)};
`;

const S_Button = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 48px;
  justify-content: center;
  width: 48px;

  &:hover {
    opacity: 0.8;
  }
  &:focus {
    outline: none;
  }
`;

const S_Title = styled.span`
  color: ${({ theme }) => theme.grey900};
  font-size: ${({ theme }) => theme.fontSizeBody2};
  font-weight: ${({ theme }) => theme.fontWeightBold};
  margin: 12px 0;
  text-align: center;
  word-break: keep-all;
`;

const S_EmptyDiv = styled(S_Button)`
  margin-left: 0;
  margin-right: 8px;
`;

const S_Empty = styled.div`
  height: 48px;
  width: 48px;
`;
export default NavBar;
